// extracted by mini-css-extract-plugin
module.exports = {"linkItem":"link-list_linkItem_2he2L","link":"link-list_link_pXBGZ"};